import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SessionService} from 'src/app/services/session.service';
import {DialogService} from '../../../services/dialog.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import {Constants} from '../constants';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements AfterViewInit, OnDestroy, OnInit {

    inSessionFlag: boolean;
    totalItems = 0;
    ngUnsubscribe: Subject<any> = new Subject<any>();
    mensaje = 0;
    infoLogin: any;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private sessionService: SessionService,
        private dialogService: DialogService,
        public router: Router,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        this.infoLogin = this.sessionService.getAuthData();
        this.sessionService.listenCartItems$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
            // tslint:disable-next-line:variable-name
            _data => {
                this.countCartItems();
            }
        );
        this.countCartItems();
    }

    ngOnInit(): void {
    }

    over(): void{
        this.mensaje = 1;
        setTimeout(() => {
            this.mensaje = 0;
        }, 3000);
    }

    goToBackOffice(): void {
        window.open(Constants.BACKOFFICE_URL
            + this.sessionService.getEncryptedData(this.infoLogin.access_token,
                Constants.configSession.userP), '_self');
    }

    changeLanguage(): void {
        window.location.href = 'https://fad.firmaautografa.com/';
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    userDataM(): any {
  
        return JSON.parse(this.sessionService.getPaymentAccount());
    }

    ngAfterViewInit(): void {
        this.inSessionFlag = this.inSession();
    }

    countCartItems(): any {
        let counter = 0;
        const cartItems = this.sessionService.getCartItems();
        cartItems.forEach(data => {
      //      counter += data.quantity;
        });
        this.totalItems = counter;
    }

    inSession(): boolean {
        const auth = this.sessionService.getAuthData();
        let sess;
        if (auth) {
            if (this.sessionService.getDayExpiration() !== String(new Date().getDate() + '/' + new Date().getMonth())) {
                this.sessionService.newDataSession();
                window.location.reload();
            } else {
                sess = this.sessionService.getLoginSession();
            }
        }
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

    login(isLogIn?: number): void {
        this.inSessionFlag = this.inSession();
        if (this.inSessionFlag) {
            this.dialogService.showConfirmationDialog(
                'Confirmar Operação',
                'Tem certeza que deseja encerrar a Sessão?',
                () => {
                    sessionStorage.clear();
                    this.sessionService.setDataPay('');
                    localStorage.clear();
                    this.sessionService.setPromoCode(null);
                    window.location.reload();
                }
            );
        } else {
            switch (isLogIn) {
                case 1:
                    this.sessionService.setInitText(true);
                    setTimeout(() => {
                        if (this.router.url === '/assinatura-digital-gratis') {
                            this.sessionService.emitNewSessionText(true);
                        } else {
                            this.router.navigate(['/assinatura-digital-gratis']);
                        }
                    }, 200);
                    break;
                case 2:
                    this.sessionService.setInitText(false);
                    setTimeout(() => {
                        if (this.router.url === '/iniciar-sessao') {
                            this.sessionService.emitNewSessionText(false);
                        } else {
                            this.router.navigate(['/iniciar-sessao']);
                        }
                    }, 200);
                    break;
            }
        }
    }

    setInitText(value): void {
        this.sessionService.setInitText(value);
        setTimeout(() => {
            if (this.router.url === '/assinatura-digital-gratis') {
                this.sessionService.emitNewSessionText(value);
            } else {
                this.router.navigate(['/assinatura-digital-gratis']);
            }
        }, 200);
    }

    openMenu(): void {
        this.dialogService.showMenu();
    }

    topWindow(): any {
        this.router.navigate(['/']);
        const x = document.querySelector('#paquetes');
        if (x) {
            x.scrollIntoView();
        }
    }
}
